import { FormHelperText } from '@material-ui/core';

const styles = (theme) => ({
  footer: {
    textAlign: 'center',
    marginTop: 45,
    marginBottom: 40,
    [theme.breakpoints.up('sm')]: {
      marginTop: 75,
      marginBottom: 45,
    },
    '& > :not(:first-child)': {
      marginTop: theme.spacing.unit * 3,
      [theme.breakpoints.up('sm')]: {
        borderLeft: `solid 1px ${theme.palette.border.light}`,
        marginTop: 0,
        marginLeft: '20px',
        paddingLeft: '20px',
      },
    },
  },
  footerItem: {
    display: 'block',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      display: 'inline-flex',
    },
    '& a': {
      fontFamily: 'Calibre',
      color: theme.palette.text.dark,
      textDecoration: 'none',
    },
    '& a:hover': {
      textDecoration: 'underline',
    },
  },
  footerIcon: {
    color: theme.palette.secondary.main,
    fontSize: '20px',
    marginRight: '5px',
  },
});

export default styles;
